import React, { useState } from 'react';

import { Card, Col, Menu, Result, Row, Typography } from 'antd';

import { AuditOutlined, HomeOutlined, TagOutlined} from '@ant-design/icons';
import Content from 'components/_Common/_Layout/Content';
import { SettingsClientManager } from 'components/Settings/SettingsClientManager';
import { AccountContextProvider } from 'lib/providers/AccountContextProvider';

import { SettingsAccount } from './SettingsAccount';
import { SettingsCategories}  from './SettingsCategories';



export function Settings() {
    type SettingOption = 'account' | 'clients' | 'categories'  ;

    const [selectedOption, setSelectedOption] = useState<SettingOption | null>(null);

    const handleClick = (e: any) => {
        setSelectedOption(e.key as 'categories');
    };

    const renderContent = () => {
        switch (selectedOption) {
        case 'account':
            return <SettingsAccount />;
        case 'clients':
            return (
                <AccountContextProvider>
                    {(value) => <SettingsClientManager />}
                </AccountContextProvider>
            );
        case 'categories':
            return <SettingsCategories />;
        
        default:
            return (
                <Result
                    status="404"
                    title="Por onde começamos?"
                    subTitle="Escolha no menu ao lado qual configuração você quer ajustar primeiro."
            
                />
            );
        }
    };

    return (
        <Content>
            <Row>
                <Col xs={24} md={14}>
                    <Typography.Title level={3}>Configurações</Typography.Title>
                    <Typography.Text>
                        Configure sua conta, organize condomínios e gerencie informações conforme suas necessidades
                    </Typography.Text>
                </Col>
            </Row>

            <Row gutter={24} style={{ marginTop: 12 }}>
                <Col xs={24} md={4}>
                    <Menu
                        mode="inline"
                        selectedKeys={selectedOption ? [selectedOption] : []}
                        onClick={handleClick}
                        style={{ borderRadius: 'var(--ant-border-radius-lg)'}}
                    > 
                        <Menu.Item key="account" icon={<AuditOutlined />}>Minha conta</Menu.Item>
                        <Menu.Item key="clients" icon={<HomeOutlined />}>Condomínios</Menu.Item>
                        <Menu.Item key="categories" icon={<TagOutlined />}>Categorias</Menu.Item>
                    </Menu>
                    
                </Col>

                <Col xs={24} md={19}>
                    <Card style={selectedOption === null ? { minHeight: 300 } : undefined}>
                        {renderContent()}
                    </Card>
                </Col>
            </Row>
        </Content>
    );
}
